import { render, staticRenderFns } from "./JzGrade.vue?vue&type=template&id=203e7482&scoped=true&"
import script from "./JzGrade.vue?vue&type=script&lang=js&"
export * from "./JzGrade.vue?vue&type=script&lang=js&"
import style0 from "./JzGrade.vue?vue&type=style&index=0&id=203e7482&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203e7482",
  null
  
)

export default component.exports